import React, { useState, useEffect, startTransition } from 'react';
import { Backdrop, CircularProgress, FormControl, Typography, Modal, Box, Grid, Radio, RadioGroup, FormControlLabel, Checkbox, Switch, colors, InputAdornment, IconButton } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Chip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import api from 'src/services/BaseService';
import moment from 'moment';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import { useLocalization } from 'src/context/LocalizationContext';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Services from 'src/services/Services';
import { useNavigate } from 'react-router-dom';

// Dolap noktası servise isBox ile, alt seçenekleri kendi alanlarıyla gider.
const DOLAP_OPTIONS = [
    { key: 'express', label: 'Express', field: 'isBoxExpress' },
    { key: 'emanet', label: 'Emanet', field: 'isBoxEmanet' },
    { key: 'handsFree', label: 'Hands Free', field: 'isBoxHandsfree' },
    { key: 'postaKutusu', label: 'Posta Kutusu', field: 'isBoxPostbox' },
];
const EMPTY_DOLAP_OPTIONS = { express: false, emanet: false, handsFree: false, postaKutusu: false };

// Express ve Posta Kutusu tek başına seçilebilir; Emanet ile Hands Free birlikte de seçilebilir.
const EXCLUSIVE_DOLAP_OPTIONS = ['express', 'postaKutusu'];

const isTruthyFlag = (value) => value === true || value === 1 || value === '1' || value === 'true';

// Servisten gelen isBox* alanlarından seçili alt seçenekler. En az bir seçenek zorunlu
// olduğundan hiçbiri seçili olmayan nokta, alt seçeneklerden önce açılmış eski bir
// Express noktasıdır; Express seçili gelir.
const getDolapOptionsFromPoint = (point) => {
    const options = DOLAP_OPTIONS.reduce((acc, { key, field }) => ({ ...acc, [key]: isTruthyFlag(point?.[field]) }), {});
    if (!Object.values(options).some(Boolean)) return { ...EMPTY_DOLAP_OPTIONS, express: true };
    return options;
};

const dolapNeedsMall = (options) => Boolean(options?.emanet || options?.handsFree);

// Nokta kaydında gönderilen tip, alt seçenek ve AVM/kat alanları.
const getBranchPayload = (formData) => {
    const isDolap = formData.selectedBranch === 'isBox';
    const options = formData.dolapOptions || EMPTY_DOLAP_OPTIONS;
    const hasMall = formData.selectedBranch === 'isEasyPoint' || (isDolap && dolapNeedsMall(options));
    return {
        isBox: isDolap,
        ...DOLAP_OPTIONS.reduce((acc, { key, field }) => ({ ...acc, [field]: isDolap && Boolean(options[key]) }), {}),
        isEasyPoint: formData.selectedBranch === 'isEasyPoint',
        isEsnaf: formData.selectedBranch === 'isEsnaf',
        floor: hasMall ? formData.floor : '',
        mallID: hasMall ? formData.mallID : '',
    };
};

const isDolapOptionDisabled = (key, options) => {
    const selected = Object.keys(options).filter((optionKey) => options[optionKey]);
    if (selected.includes(key)) return false;
    if (selected.some((optionKey) => EXCLUSIVE_DOLAP_OPTIONS.includes(optionKey))) return true;
    return EXCLUSIVE_DOLAP_OPTIONS.includes(key) && selected.length > 0;
};

const AddEditPointModal = ({
    open,
    onClose,
    isEdit,
    editData,
    malls,
    userList,
    setEditData,
    applicationData,
    responsibleRegions = [],
}) => {
    const { language } = useLocalization();
    const navigate = useNavigate();
    const [showResultMessage, setShowResultMessage] = useState(false);
    const [resultMessage, setResultMessage] = useState('');
    const [createdPointId, setCreatedPointId] = useState(null); // Yeni oluşturulan nokta ID'si
    const [isBackdropOpen, setIsBackdropOpen] = useState(true);
    const [workingDays, setWorkingDays] = useState([]);
    const [amazonWorkStatus, setAmazonWorkStatus] = useState(false);
    const [trendyolWorkStatus, setTrendyolWorkStatus] = useState(false);
    const [hepsiburadaWorkStatus, setHepsiburadaWorkStatus] = useState(false);
    const [kargoistWorkStatus, setKargoistWorkStatus] = useState(false);
    const [hepsijetWorkStatus, setHepsijetWorkStatus] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [closedDates, setClosedDates] = useState([]);
    const [closedTimeStart, setClosedTimeStart] = useState();
    const [closedTimeEnd, setClosedTimeEnd] = useState();
    const [originalUserList, setOriginalUserList] = useState([]);
    const [isActive, setIsActive] = useState();
    const [isBolparaActive, setIsBolparaActive] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [unformattedDates, setUnformattedDates] = useState([]);

    const [duplicateArasKargo, setDuplicateArasKargo] = useState(false);
    const [duplicateBranch, setDuplicateBranch] = useState(false);
    const [duplicateKargoist, setDuplicateKargoist] = useState(false);

    const [cityList, setCityList] = useState([]);
    const [selectedCityCode, setSelectedCityCode] = useState("");

    const [townList, setTownList] = useState([]);
    const [selectedTownCode, setSelectedTownCode] = useState("");

    const [regionList, setRegionList] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedResponsibleRegionId, setSelectedResponsibleRegionId] = useState("");

    const [arasKargoChecked, setArasKargoChecked] = useState(false);
    const [hepsiJetChecked, setHepsiJetChecked] = useState(false);
    const [kargoistChecked, setKargoistChecked] = useState(false);
    const [suratKargoChecked, setSuratKargoChecked] = useState(false);
    const [duplicateSuratKargo, setDuplicateSuratKargo] = useState(false);

    const days = [
        language.commons.days.monday,
        language.commons.days.tuesday,
        language.commons.days.wednesday,
        language.commons.days.thursday,
        language.commons.days.friday,
        language.commons.days.saturday,
        language.commons.days.sunday
    ]
    const [formData, setFormData] = useState({
        users: [],
        selectedBranch: '',
        dolapOptions: { ...EMPTY_DOLAP_OPTIONS },
        isAmazon: false,
        isTrendyol: false,
        isHepsiburada: false,
        isHepsijet: false,
        isArasKargo: false,
        isKargoist: false,
        isSuratKargo: false,
        hasPhysicalPOS: false,
        isCash: false,
        canUploadInvoice: false,
        title: "",
        amazonHubTitle: "",
        amazonAddress1: "",
        amazonAddress2: "",
        arasKargoID: "",
        kargoistID: "",
        hepsijetID: "",
        suratKargoID: "",
        phone: "",
        email: "",
        city: "",
        region: "",
        district: "",
        address: "",
        address2: "",
        postCode: "",
        mallID: "",
        floor: "",
        latitude: "",
        longitude: "",
        branchCode: "",
        branchSubCode: "",
        prefix: "",
        dailyCapacity: "1000",
        getirID: "",
        workingDaysText: "",
        workingDays: {
            monday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            tuesday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            wednesday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            thursday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            friday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            saturday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            },
            sunday: {
                enable: "off",
                openingTime: {
                    hour: "00",
                    minute: "00"
                },
                closingTime: {
                    hour: "00",
                    minute: "00"
                }
            }
        },
        pointAddressDefinition: ""
    });

    const selectedResponsibleRegion = responsibleRegions.find(
        (item) => String(item.id) === String(selectedResponsibleRegionId)
    );
    const responsibleFullName = selectedResponsibleRegion?.responsibleName || '';
    const responsiblePhone = selectedResponsibleRegion?.phone || '';

    const [initialDataLoaded, setInitialDataLoaded] = useState(false);
    const [loadedEditId, setLoadedEditId] = useState(null);

    useEffect(() => {
        if (!open) {
            setInitialDataLoaded(false);
            setLoadedEditId(null);
            return;
        }

        if (initialDataLoaded && loadedEditId === editData?.id) {
            return;
        }

        const parsedUser = JSON.parse(localStorage.getItem('user'));
        Services.GetCities(parsedUser.token)
            .then((res) => {
                setCityList(res.data.result)

                if (isEdit && editData) {
                    const city = res.data.result.find(item => item.name.toLocaleUpperCase("tr") === editData?.city?.toLocaleUpperCase("tr"));

                    if (city) {
                        Services.GetTowns(city?.code)
                            .then((res) => {
                                setTownList(res.data.result)
                                const town = res.data.result?.find(item => item.name.toLocaleUpperCase("tr") === editData?.district?.toLocaleUpperCase("tr"));
                                if (town) {
                                    Services.GetRegions(town?.code)
                                        .then((res) => {
                                            setRegionList(res.data.result)
                                        })
                                        .catch((err) => console.log());
                                }
                            })
                            .catch((err) => console.log(err));
                    }
                }

                setInitialDataLoaded(true);
                setLoadedEditId(editData?.id || null);
            })
            .catch((err) => console.log(err));

    }, [open, editData?.id]);

    // Başvuru bilgilerini form alanlarına doldur
    useEffect(() => {
        if (applicationData && open && !isEdit) {
            const parsedUser = JSON.parse(localStorage.getItem('user'));

            // Şube tipini belirle (Easy Point Esnaf -> isEsnaf)
            let selectedBranch = '';
            if (applicationData.whichService) {
                const service = applicationData.whichService.toLowerCase();
                if (service.includes('esnaf')) {
                    selectedBranch = 'isEsnaf';
                } else if (service.includes('desk') || service.includes('easy point desk')) {
                    selectedBranch = 'isEasyPoint';
                }
            }

            // Çalışma saatlerini dönüştür
            let workingDaysData = { ...formData.workingDays };
            let enabledDays = []; // Checkbox'lar için aktif günler

            if (applicationData.workingHours) {
                const dayMapping = {
                    monday: 'monday',
                    tuesday: 'tuesday',
                    wednesday: 'wednesday',
                    thursday: 'thursday',
                    friday: 'friday',
                    saturday: 'saturday',
                    sunday: 'sunday'
                };

                Object.keys(dayMapping).forEach(day => {
                    const dayData = applicationData.workingHours[day];
                    if (dayData && dayData.open) {
                        const [startHour, startMinute] = (dayData.start || '00:00').split(':');
                        const [endHour, endMinute] = (dayData.end || '00:00').split(':');

                        workingDaysData[day] = {
                            enable: 'on',
                            openingTime: {
                                hour: startHour.padStart(2, '0'),
                                minute: startMinute.padStart(2, '0')
                            },
                            closingTime: {
                                hour: endHour.padStart(2, '0'),
                                minute: endMinute.padStart(2, '0')
                            }
                        };

                        // Checkbox için günü ekle
                        enabledDays.push(day);
                    }
                });
            }

            // Checkbox'ları güncelle
            setWorkingDays(enabledDays);

            // Form verilerini güncelle
            // Başlık ve adres alanlarına "Easy Point Esnaf - " prefix'i ekle
            const titleWithPrefix = applicationData.title ? `Easy Point ${selectedBranch === 'isEsnaf' ? 'Esnaf' : 'Desk'} - ${applicationData.title}` : prev.title;
            const addressWithPrefix = applicationData.address ? `Easy Point ${selectedBranch === 'isEsnaf' ? 'Esnaf' : 'Desk'} - ${applicationData.address}` : prev.address;

            setFormData(prev => ({
                ...prev,
                title: titleWithPrefix,
                phone: applicationData.phone || prev.phone,
                email: applicationData.email || prev.email,
                address: addressWithPrefix,
                selectedBranch: selectedBranch || prev.selectedBranch,
                workingDays: workingDaysData,
            }));

            // Şehir bilgisi varsa, şehir listesinden bul ve seç
            if (applicationData.city && cityList.length > 0) {
                const city = cityList.find(
                    item => item.name.toLocaleUpperCase("tr") === applicationData.city.toLocaleUpperCase("tr")
                );

                if (city) {
                    setSelectedCityCode(city.code);

                    // FormData'ya şehir bilgisini ekle
                    setFormData(prev => ({
                        ...prev,
                        city: city.name
                    }));

                    // İlçe listesini getir
                    Services.GetTowns(city.code)
                        .then((res) => {
                            setTownList(res.data.result);

                            // İlçe bilgisi varsa, ilçe listesinden bul ve seç
                            if (applicationData.district) {
                                const town = res.data.result?.find(
                                    item => item.name.toLocaleUpperCase("tr") === applicationData.district.toLocaleUpperCase("tr")
                                );

                                if (town) {
                                    setSelectedTownCode(town.code);

                                    // FormData'ya ilçe bilgisini ekle
                                    setFormData(prev => ({
                                        ...prev,
                                        district: town.name
                                    }));

                                    // Mahalle listesini getir
                                    Services.GetRegions(town.code)
                                        .then((res) => {
                                            setRegionList(res.data.result);

                                            // Mahalle bilgisi varsa, mahalle listesinden bul ve seç
                                            if (applicationData.neighborhood) {
                                                const region = res.data.result?.find(
                                                    item => item.name.toLocaleUpperCase("tr") === applicationData.neighborhood.toLocaleUpperCase("tr")
                                                );

                                                if (region) {
                                                    setSelectedRegion(region.code);

                                                    // FormData'ya mahalle bilgisini ekle
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        region: region.name
                                                    }));
                                                }
                                            }
                                        })
                                        .catch((err) => console.log(err));
                                }
                            }
                        })
                        .catch((err) => console.log(err));
                }
            }
        }
    }, [applicationData, open, isEdit, cityList]);

    const handleDeleteClosedDate = (index) => {
        const updatedDates = [...closedDates];
        updatedDates.splice(index, 1);
        setClosedDates(updatedDates);
    };

    function formatDateRange(obj) {
        const formatDateTime = (dateStr, timeStr) => {
            // "21.10.2025" → ["21", "10", "2025"]
            const [day, month, year] = dateStr.split('.');
            // Gerekli formatta birleştir
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')} ${timeStr}`;
        };

        const start = formatDateTime(obj.startDate, obj.startTime);
        const end = formatDateTime(obj.endDate, obj.endTime);
        return { start, end };
    }

    // Örnek kullanım:
    const input = {
        startDate: "21.10.2025",
        startTime: "04:00",
        endDate: "23.10.2025",
        endTime: "05:00"
    };

    const handleAddClosedDates = () => {
        const options = { timeZone: 'Europe/Istanbul', hour12: false, hour: '2-digit', minute: '2-digit' };

        const formatDateToTimestamp = (dateString, timeString) => {
            const [day, month, year] = dateString.split('.');
            const [hours, minutes] = timeString.split(':');

            const formattedDate = new Date(
                parseInt(year, 10),
                parseInt(month, 10) - 1,
                parseInt(day, 10),
                parseInt(hours, 10),
                parseInt(minutes, 10)
            );

            return formattedDate.getTime() / 1000;
        };

        const formattedStartTime = new Date(closedTimeStart).toLocaleTimeString('tr-TR', options);
        const formattedEndTime = new Date(closedTimeEnd).toLocaleTimeString('tr-TR', options);

        const startDateFormatted = new Date(startDate).toLocaleDateString('tr-TR');
        const endDateFormatted = new Date(endDate).toLocaleDateString('tr-TR');

        const dateStartTimestamp = formatDateToTimestamp(startDateFormatted, formattedStartTime);
        const dateEndTimestamp = formatDateToTimestamp(endDateFormatted, formattedEndTime);
        setUnformattedDates({ startDate: startDateFormatted, startTime: formattedStartTime, endDate: endDateFormatted, endTime: formattedEndTime })
        setClosedDates([...closedDates, { startDate: dateStartTimestamp, endDate: dateEndTimestamp }]);
        setStartDate(null);
        setEndDate(null);
        setClosedTimeStart(null);
        setClosedTimeEnd(null);
    };

    const handleSetClosedDates = () => {
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        let closedDates = (formatDateRange(unformattedDates))

        Services.EPCentersSetClosedDates(parsedUser.token, [editData.id], closedDates.start, closedDates.end)
            .then((res) => {
            })
            .catch((err) => console.log());
    }

    const handleSave = async (goToUsers = false) => {
        setIsBackdropOpen(true)
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        if (formData.arasKargoID) {
            if (!isEdit || (isEdit && formData.arasKargoID !== editData.arasKargoID)) {
                try {
                    const res = await Services.CheckEasypointCenterDuplicate(parsedUser.token, "arasKargoID", formData.arasKargoID);
                    if (res.data.status) {
                        // toast.error("Aras Kargo ID zaten mevcut.");
                        setIsBackdropOpen(false);
                        return;
                    }
                } catch (err) {
                    console.log(err);
                    setIsBackdropOpen(false);
                    return;
                }
            }
        }

        if (formData.suratKargoID) {
            if (!isEdit || (isEdit && formData.suratKargoID !== editData.suratKargoID)) {
                try {
                    const res = await Services.CheckEasypointCenterDuplicate(parsedUser.token, "suratKargoID", formData.suratKargoID);
                    if (res.data.status) {
                        setIsBackdropOpen(false);
                        return;
                    }
                } catch (err) {
                    console.log(err);
                    setIsBackdropOpen(false);
                    return;
                }
            }
        }

        if (formData.kargoistID) {
            if (!isEdit || (isEdit && formData.kargoistID !== editData.kargoistID)) {
                try {
                    const res = await Services.CheckEasypointCenterDuplicate(parsedUser.token, "kargoistID", formData.kargoistID);
                    if (res.data.status) {
                        // toast.error("Kargoist ID zaten mevcut.");
                        setIsBackdropOpen(false);
                        return;
                    }
                } catch (err) {
                    console.log(err);
                    setIsBackdropOpen(false);
                    return;
                }
            }
        }

        if (formData.branchCode) {
            if (!isEdit || (isEdit && formData.branchCode !== editData.branchCode)) {
                try {
                    const res = await Services.CheckEasypointCenterDuplicate(parsedUser.token, "branchCode", formData.branchCode);
                    if (res.data.status) {
                        // toast.error("Şube Kodu zaten mevcut.");
                        setIsBackdropOpen(false);
                        return;
                    }
                } catch (err) {
                    console.log(err);
                    setIsBackdropOpen(false);
                    return;
                }
            }
        }

        if (!isEdit) {
            if (formData.getirID !== "" && formData.getirID !== null) {
                api
                    .post('/easypoint-centers/create', {
                        title: formData.title,
                        amazonTitle: formData.amazonHubTitle,
                        amazonAddress1: formData.amazonAddress1,
                        amazonAddress2: formData.amazonAddress2,
                        ...getBranchPayload(formData),
                        isMuhaberat: false,
                        isMalKabul: false,
                        isAmazon: formData.isAmazon,
                        isActiveOnAmazon: formData.isAmazon ? "1" : "0",
                        isTrendyol: formData.isTrendyol,
                        isActiveOnTrendyol: formData.isTrendyol ? "1" : "0",
                        isHepsiburada: formData.isHepsiburada,
                        isActiveOnHepsiburada: formData.isHepsiburada ? "1" : "0",
                        isHepsijet: formData.isHepsijet,
                        isActiveOnHepsijet: formData.isHepsijet ? "1" : "0",
                        isArasKargo: formData.isArasKargo,
                        isKargoist: formData.isKargoist,
                        kargoistID: formData.kargoistID,
                        isActiveOnKargoist: formData.isKargoist ? "1" : "0",
                        arasKargoID: formData.arasKargoID,
                        hepsijetID: formData.hepsijetID,
                        isSuratKargo: formData.isSuratKargo,
                        isN11: false,
                        packageCapacity: formData.dailyCapacity,
                        phone: formData.phone,
                        city: formData.city,
                        region: formData.region,
                        district: formData.district,
                        postalCode: formData.postCode,
                        muhaberatAddress1: formData.address,
                        muhaberatAddress2: formData.address2,
                        latitude: formData.latitude,
                        longitude: formData.longitude,
                        email: formData.email,
                        branchCode: formData.branchCode,
                        subBranchCode: formData.branchSubCode,
                        prefix: formData.prefix,
                        getirID: formData.getirID,
                        amazonID: "",
                        workingDaysText: formData.workingDaysText,
                        workingDays: formData.workingDays,
                        closedDates: closedDates,
                        status: true,
                        isBolparaActive: isBolparaActive,
                        pointAddressDefinition: formData.pointAddressDefinition,
                        hasPhysicalPOS: formData.hasPhysicalPOS ? "1" : "0",
                        isCash: formData.isCash ? "1" : "0",
                        canUploadInvoice: formData.canUploadInvoice ? "1" : "0",
                        pointDistrict: selectedResponsibleRegionId || "0"
                    })
                    .then((response) => {
                        if (response.data.status) {
                            const newPointId = response.data.result?.id || response.data.result;

                            // Eğer applicationData varsa veya kullanıcı 'Kaydet ve Noktaya Git' butonuna bastıysa, kullanıcı sayfasına yönlendir
                            if (applicationData && goToUsers) {
                                setCreatedPointId(newPointId);
                                setShowResultMessage(true);
                                setResultMessage("Nokta başarıyla eklendi. Kullanıcı ekleme sayfasına yönlendiriliyorsunuz...");
                                setIsBackdropOpen(false);

                                // 1.5 saniye sonra yönlendir
                                setTimeout(() => {
                                    navigate(`/dashboard/users?openAddModal=true&pointId=${newPointId}&userType=esnaf`);
                                }, 1500);
                            } else {
                                setShowResultMessage(true);
                                setResultMessage("Nokta başarıyla eklendi.");
                                setIsBackdropOpen(false);
                            }

                        } else {
                            setShowResultMessage(true)
                            setResultMessage("Nokta eklenirken bir sorunla karşılaşıldı!")
                            setIsBackdropOpen(false)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error(error.message);
                    });
            }
            else {
                api
                    .post('/easypoint-centers/create', {
                        title: formData.title,
                        amazonTitle: formData.amazonHubTitle,
                        amazonAddress1: formData.amazonAddress1,
                        amazonAddress2: formData.amazonAddress2,
                        ...getBranchPayload(formData),
                        isMuhaberat: false,
                        isMalKabul: false,
                        isAmazon: formData.isAmazon,
                        isActiveOnAmazon: formData.isAmazon ? "1" : "0",
                        isTrendyol: formData.isTrendyol,
                        isActiveOnTrendyol: formData.isTrendyol ? "1" : "0",
                        isHepsiburada: formData.isHepsiburada,
                        isActiveOnHepsiburada: formData.isHepsiburada ? "1" : "0",
                        isKargoist: formData.isKargoist,
                        isActiveOnKargoist: formData.isKargoist ? "1" : "0",
                        isHepsijet: formData.isHepsijet,
                        isActiveOnHepsijet: formData.isHepsijet ? "1" : "0",
                        isArasKargo: formData.isArasKargo,
                        arasKargoID: formData.arasKargoID,
                        kargoistID: formData.kargoistID,
                        hepsijetID: formData.hepsijetID,
                        isSuratKargo: formData.isSuratKargo,
                        isN11: false,
                        packageCapacity: formData.dailyCapacity,
                        phone: formData.phone,
                        city: formData.city,
                        region: formData.region,
                        district: formData.district,
                        postalCode: formData.postCode,
                        muhaberatAddress1: formData.address,
                        muhaberatAddress2: formData.address2,
                        latitude: formData.latitude,
                        longitude: formData.longitude,
                        email: formData.email,
                        branchCode: formData.branchCode,
                        subBranchCode: formData.branchSubCode,
                        prefix: formData.prefix,
                        amazonID: "",
                        workingDaysText: formData.workingDaysText,
                        workingDays: formData.workingDays,
                        closedDates: closedDates,
                        isBolparaActive: isBolparaActive,
                        pointAddressDefinition: formData.pointAddressDefinition,
                        hasPhysicalPOS: formData.hasPhysicalPOS ? "1" : "0",
                        isCash: formData.isCash ? "1" : "0",
                        canUploadInvoice: formData.canUploadInvoice ? "1" : "0",
                        pointDistrict: selectedResponsibleRegionId || "0",
                        status: true,
                    })
                    .then((response) => {
                        if (response.data.status) {
                            const newPointId = response.data.result?.id || response.data.result;

                            // Eğer applicationData varsa veya kullanıcı 'Kaydet ve Noktaya Git' butonuna bastıysa, kullanıcı sayfasına yönlendir
                            if (applicationData || goToUsers) {
                                setCreatedPointId(newPointId);
                                setShowResultMessage(true);
                                setResultMessage("Nokta başarıyla eklendi. Kullanıcı ekleme sayfasına yönlendiriliyorsunuz...");
                                setIsBackdropOpen(false);

                                // 1.5 saniye sonra yönlendir
                                setTimeout(() => {
                                    navigate(`/dashboard/users?openAddModal=true&pointId=${newPointId}&userType=esnaf`);
                                }, 1500);
                            } else {
                                setShowResultMessage(true);
                                setResultMessage("Nokta başarıyla eklendi.");
                                setIsBackdropOpen(false);
                            }

                        } else {
                            setShowResultMessage(true)
                            setResultMessage("Nokta eklenirken bir sorunla karşılaşıldı!")
                            setIsBackdropOpen(false)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error(error.message);
                    });
            }
        }
        else {
            const districtPayload = { pointDistrict: selectedResponsibleRegionId || "0" };

            api
                .post('/easypoint-centers/update', {
                    id: editData.id,
                    title: formData.title,
                    amazonTitle: formData.amazonHubTitle,
                    amazonAddress1: formData.amazonAddress1,
                    amazonAddress2: formData.amazonAddress2,
                    ...getBranchPayload(formData),
                    isMuhaberat: false,
                    isMalKabul: false,
                    isAmazon: formData.isAmazon,
                    isActiveOnAmazon: amazonWorkStatus ? "1" : "0",
                    isTrendyol: formData.isTrendyol,
                    isActiveOnTrendyol: trendyolWorkStatus ? "1" : "0",
                    isHepsiburada: formData.isHepsiburada,
                    isActiveOnHepsiburada: hepsiburadaWorkStatus ? "1" : "0",
                    isKargoist: formData.isKargoist,
                    isActiveOnKargoist: kargoistWorkStatus ? "1" : "0",
                    isHepsijet: formData.isHepsijet,
                    isActiveOnHepsijet: hepsijetWorkStatus ? "1" : "0",
                    isSuratKargo: formData.isSuratKargo,
                    isArasKargo: formData.isArasKargo,
                    arasKargoID: formData.arasKargoID,
                    kargoistID: formData.kargoistID,
                    hepsijetID: formData.hepsijetID,
                    isN11: false,
                    packageCapacity: formData.dailyCapacity,
                    phone: formData.phone,
                    city: formData.city,
                    region: formData.region,
                    district: formData.district,
                    postalCode: formData.postCode,
                    muhaberatAddress1: formData.address,
                    muhaberatAddress2: formData.address2,
                    latitude: formData.latitude,
                    longitude: formData.longitude,
                    email: formData.email,
                    branchCode: formData.branchCode,
                    subBranchCode: formData.branchSubCode,
                    prefix: formData.prefix,
                    getirID: formData.getirID,
                    amazonID: "",
                    workingDaysText: formData.workingDaysText,
                    workingDays: formData.workingDays,
                    closedDates: closedDates,
                    status: isActive ? "1" : "0",
                    isBolparaActive: isBolparaActive,
                    pointAddressDefinition: formData.pointAddressDefinition,
                    hasPhysicalPOS: formData.hasPhysicalPOS ? "1" : "0",
                    isCash: formData.isCash ? "1" : "0",
                    canUploadInvoice: formData.canUploadInvoice ? "1" : "0",
                    ...districtPayload
                })
                .then((response) => {
                    if (response.data.status) {
                        if (Array.isArray(unformattedDates) && unformattedDates.length > 0) {
                            handleSetClosedDates()
                        }
                        setShowResultMessage(true)
                        setResultMessage("Nokta başarıyla düzenlendi.")
                        setIsBackdropOpen(false)
                    } else {
                        setShowResultMessage(true)
                        setResultMessage("Nokta düzenlenirken bir sorunla karşılaşıldı!")
                        setIsBackdropOpen(false)
                    }
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(error.message);
                });
        }

    }

    const compareHHMM = (aHour, aMin, bHour, bMin) => {
        // a < b ise true döner
        const a = Number(aHour) * 60 + Number(aMin);
        const b = Number(bHour) * 60 + Number(bMin);
        return a < b;
    };

    const isValidWorkingDays = (workingDaysObj) => {
        return Object.values(workingDaysObj).some((d) => d.enable === "on");
    };

    // --- Güncellenmiş allFieldsAreValid (tamamını değiştir) ---
    const allFieldsAreValid = () => {
        // Ortak zorunlular
        if (!formData?.latitude || !formData?.longitude) return false;            // Enlem & Boylam zorunlu
        if (formData?.isHepsiburada && !formData?.branchCode) return false;       // Hepsiburada → branchCode zorunlu
        if (!isValidWorkingDays(formData?.workingDays)) return false;              // Çalışma gün/saat kuralı

        // Ortak alanlar (her iki şube tipi için de kontrol ettiğin alanlar)
        const commonOk =
            formData?.title !== '' &&
            formData?.email !== '' &&
            formData?.city !== '' &&
            formData?.district !== '' &&
            formData?.postCode !== '' &&
            formData?.dailyCapacity !== '' &&
            formData?.selectedBranch !== '' &&
            (!hepsiJetChecked || (formData?.hepsijetID !== '' && formData?.hepsijetID !== null));

        if (!commonOk) return false;

        // Kargoist seçiliyse ID zorunlu
        if (kargoistChecked && (formData?.kargoistID === "" || formData?.kargoistID === null)) return false;

        // if (suratKargoChecked && (formData?.suratKargoID === "" || formData?.suratKargoID === null)) return false;

        // Amazon / Aras kombinasyon kuralları
        const amazonOkOnly =
            formData?.isAmazon &&
            !arasKargoChecked;

        const arasOkOnly =
            arasKargoChecked &&
            !formData?.isAmazon &&
            formData?.arasKargoID;

        const amazonAndArasOk =
            formData?.isAmazon &&
            arasKargoChecked && formData?.arasKargoID;

        const noneAmazonArasOk = !formData?.isAmazon && !arasKargoChecked;

        const amazonArasRuleOk = amazonOkOnly || arasOkOnly || amazonAndArasOk || noneAmazonArasOk;

        if (!amazonArasRuleOk) return false;

        // Şube tipine özel kontroller
        if (formData?.selectedBranch === 'isEsnaf') {
            return true;
        }

        // Dolap'ta en az bir alt seçenek zorunlu; Emanet / Hands Free AVM içinde olduğu için AVM de zorunlu.
        if (formData?.selectedBranch === 'isBox') {
            const options = formData.dolapOptions || EMPTY_DOLAP_OPTIONS;
            if (!Object.values(options).some(Boolean)) return false;
            if (dolapNeedsMall(options) && !formData?.mallID) return false;
            return true;
        }

        if (formData?.selectedBranch === 'isEasyPoint') {
            // EasyPoint'te mallID zorunlu
            if (!formData?.mallID) return false;
            return true;
        }

        return false;
    };


    const handleSwitchChange = () => {
        const { name, value } = event.target;
        if (name === "amazonWorkStatus") {
            setAmazonWorkStatus(!amazonWorkStatus)
        }
        else if (name === "trendyolWorkStatus") {
            setTrendyolWorkStatus(!trendyolWorkStatus)
        }
        else if (name === "kargoistWorkStatus") {
            setKargoistWorkStatus(!kargoistWorkStatus)
        }
        else if (name === "hepsiburadaWorkStatus") {
            setHepsiburadaWorkStatus(!hepsiburadaWorkStatus)
        }
        else if (name === "hepsijetWorkStatus") {
            setHepsijetWorkStatus(!hepsijetWorkStatus)
        }
        else if (name === "arasKargoWorkStatus") {
            setFormData({
                ...formData,
                isArasKargo: (!formData.isArasKargo)
            });
        }
        else if (name === "isActive") {
            setIsActive(!isActive)
        }
        else if (name === "isBolparaActive") {
            setIsBolparaActive(!isBolparaActive)
        }
    };

    const handleDayChange = (event) => {
        const day = event.target.name;
        const isChecked = event.target.checked;
        let updateWorkingDaysArr = [...workingDays];

        if (isChecked) {
            updateWorkingDaysArr.push(day);
        }
        else {
            updateWorkingDaysArr = updateWorkingDaysArr.filter((item) => item !== day);
        }
        setWorkingDays(updateWorkingDaysArr)
        const updatedFormData = { ...formData };

        updatedFormData.workingDays[day].enable = updatedFormData.workingDays[day].enable === "on" ? "off" : "on";
        updatedFormData.workingDays[day].openingTime.hour = "00";
        updatedFormData.workingDays[day].openingTime.minute = "00";

        updatedFormData.workingDays[day].closingTime.hour = "00";
        updatedFormData.workingDays[day].closingTime.minute = "00";

        setFormData(updatedFormData);
    };

    const handleTextFieldChange = (e) => {
        const parsedUser = JSON.parse(localStorage.getItem('user'));

        const { name, value } = e.target;

        if (name === "city") {
            const city = cityList.find(item => item.name.toLowerCase() === value.toLowerCase());
            setSelectedCityCode(city.code)

            setFormData({
                ...formData,
                district: "",
                region: "",
                [name]: value
            });

            Services.GetTowns(city.code)
                .then((res) => {
                    setTownList(res.data.result)
                })
                .catch((err) => console.log(err));
        }

        else if (name === "district") {
            const town = townList.find(item => item.name.toLowerCase() === value.toLowerCase());
            setSelectedTownCode(town.code)
            setFormData({
                ...formData,
                region: "",
                [name]: value
            });

            Services.GetRegions(town.code)
                .then((res) => {
                    setRegionList(res.data.result)
                })
                .catch((err) => console.log(err));
        }

        else if (name === "dailyCapacity") {
            setFormData({
                ...formData,
                [name]: Math.abs(value)
            });
        }

        else {
            setFormData({
                ...formData,
                [name]: value
            });
        }


    };

    const handleChangeBranch = (event) => {
        setFormData({
            ...formData,
            selectedBranch: event.target.value,
            mallID: "",
            floor: "",
            dolapOptions: { ...EMPTY_DOLAP_OPTIONS },
        });
    };

    const handleChangeDolapOption = (event) => {
        const { name, checked } = event.target;
        setFormData((prev) => {
            const dolapOptions = { ...(prev.dolapOptions || EMPTY_DOLAP_OPTIONS), [name]: checked };
            const needsMall = dolapNeedsMall(dolapOptions);
            return {
                ...prev,
                dolapOptions,
                // AVM gerektiren seçenek kalmadıysa önceki AVM/kat seçimi taşınmasın.
                ...(needsMall ? {} : { mallID: '', floor: '' }),
            };
        });
    };

    // AVM ve kat alanları: Easy Point noktasında, bir de AVM içinde duran Emanet /
    // Hands Free dolaplarında gösterilir.
    const showMallFields =
        formData.selectedBranch === 'isEasyPoint' ||
        (formData.selectedBranch === 'isBox' && dolapNeedsMall(formData.dolapOptions));

    const handleCheckDuplicate = (field, value) => {
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        Services.CheckEasypointCenterDuplicate(parsedUser.token, field, value)
            .then((res) => {
                if (res.data.status) {
                    // Duplicate varsa hata mesajı göster
                    toast.error(`${field === 'arasKargoID' ? "Aras Kargo ID" : field === 'hepsijetID' ? "HepsiJet ID" : field === "kargoistID" ? "Kargoist ID" : field === "suratKargoID" ? "Sürat Kargo ID" : "Şube Kodu"} zaten mevcut.`);
                    if (field === "arasKargoID") {
                        setDuplicateArasKargo(true);
                    } else if (field === "branchCode") {
                        setDuplicateBranch(true);
                    }
                    else if (field === "kargoistID") {
                        setDuplicateKargoist(true)
                    } else if (field === "suratKargoID") {
                        setDuplicateSuratKargo(true);
                    }
                } else {
                    // Duplicate yoksa ilgili state'leri sıfırla
                    if (field === "arasKargoID") {
                        setDuplicateArasKargo(false);
                    } else if (field === "branchCode") {
                        setDuplicateBranch(false);
                    }
                    else if (field === "kargoistID") {
                        setDuplicateKargoist(true)
                    } else if (field === "suratKargoID") {
                        setDuplicateSuratKargo(false);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleChangePartners = (event) => {
        if (event.target.name === "isAmazon") {
            setFormData({
                ...formData,
                [event.target.name]: event.target.checked
            });
            setAmazonWorkStatus(false)
        }
        else if (event.target.name === "isTrendyol") {
            setFormData({
                ...formData,
                [event.target.name]: event.target.checked
            });
            setTrendyolWorkStatus(false)
        }
        else if (event.target.name === 'isHepsiburada') {
            setFormData({
                ...formData,
                [event.target.name]: event.target.checked
            });
            setHepsiburadaWorkStatus(false)
        }
        else if (event.target.name === 'isKargoist') {
            setFormData({
                ...formData,
                kargoistID: "",
                [event.target.name]: event.target.checked
            });
            setKargoistChecked(event.target.checked)
            setKargoistWorkStatus(event.target.checked)
        }
        else if (event.target.name === 'isHepsiJet') {
            setFormData({
                ...formData,
                hepsijetID: "",
                isHepsijet: false
            });
            setHepsiJetChecked(event.target.checked)
        }
        else if (event.target.name === 'isArasKargo') {
            setFormData({
                ...formData,
                arasKargoID: "",
                isArasKargo: false
            });
            setArasKargoChecked(event.target.checked)
        } else if (event.target.name === 'isSuratKargo') {
            const isChecked = event.target.checked;
            setFormData({
                ...formData,
                suratKargoID: "",
                isSuratKargo: isChecked,
            });
            setSuratKargoChecked(event.target.checked)
        }

    };

    const handleClose = () => {
        setFormData({ dailyCapacity: "10000" });
        onClose()
    }

    const handleCloseMessage = () => {
        setShowResultMessage(false)
        setFormData({ dailyCapacity: "10000" });
        onClose()
    }

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
    };

    const handleOpeningTimeChange = (newTime, day) => {
        // Yeni saat değerini formData içindeki ilgili günün openingTime'a atayın
        const updatedFormData = { ...formData };
        updatedFormData.workingDays[day].openingTime.hour = moment(newTime).format('HH');
        updatedFormData.workingDays[day].openingTime.minute = moment(newTime).format('mm');
        setFormData(updatedFormData);
    };

    const handleClosingTimeChange = (newTime, day) => {
        // Yeni saat değerini formData içindeki ilgili günün closingTime'a atayın
        const updatedFormData = { ...formData };
        updatedFormData.workingDays[day].closingTime.hour = moment(newTime).format('HH');
        updatedFormData.workingDays[day].closingTime.minute = moment(newTime).format('mm');
        setFormData(updatedFormData);
    };

    useEffect(() => {
        setIsBackdropOpen(false);

        if (isEdit) {
            const defaultDayTemplate = {
                enable: "off",
                openingTime: { hour: "00", minute: "00" },
                closingTime: { hour: "00", minute: "00" }
            };

            const defaultWorkingDays = {
                monday: { ...defaultDayTemplate },
                tuesday: { ...defaultDayTemplate },
                wednesday: { ...defaultDayTemplate },
                thursday: { ...defaultDayTemplate },
                friday: { ...defaultDayTemplate },
                saturday: { ...defaultDayTemplate },
                sunday: { ...defaultDayTemplate }
            };

            let safeWorkingDays = defaultWorkingDays;

            // Eğer gelen veri geçerli bir OBJEYSE (ve null değilse), varsayılanla birleştir.
            // Eğer "false" string'i, null veya undefined gelirse defaultWorkingDays kullanılır.
            if (editData.workingDays && typeof editData.workingDays === 'object') {
                safeWorkingDays = { ...defaultWorkingDays, ...editData.workingDays };
            }
            const getSafeDayData = (dayKey) => {
                const dayData = safeWorkingDays[dayKey] || defaultDayTemplate;
                return {
                    enable: dayData.enable || "off",
                    openingTime: {
                        hour: dayData.openingTime?.hour || "00",
                        minute: dayData.openingTime?.minute || "00"
                    },
                    closingTime: {
                        hour: dayData.closingTime?.hour || "00",
                        minute: dayData.closingTime?.minute || "00"
                    }
                };
            };

            let selectedBranchValue = "";
            if (editData.isEsnaf === "1") {
                selectedBranchValue = "isEsnaf";
            } else if (editData.isEasyPoint === "1") {
                selectedBranchValue = "isEasyPoint";
            } else if (editData.isBox === "1") {
                selectedBranchValue = "isBox";
            }

            let closedDatesState = [];
            if (Array.isArray(editData.closedDates)) {
                closedDatesState = editData.closedDates;
            } else if (editData.closedDates && !Array.isArray(editData.closedDates)) {
                closedDatesState = [editData.closedDates];
            }

            const formatedUserList = userList.filter(item2 => editData.users?.some(item1 => item1.id === item2.id));

            // Checkbox'ların seçili gelmesi için enable olan günleri filtrele
            const filteredDays = Object.keys(safeWorkingDays).filter(day => safeWorkingDays[day]?.enable === "on");

            setWorkingDays(filteredDays);
            setClosedDates(closedDatesState);
            setOriginalUserList(editData.users ? formatedUserList : []);

            // Boolean Status Atamaları
            setAmazonWorkStatus(editData.isActiveOnAmazon === "1");
            setTrendyolWorkStatus(editData.isActiveOnTrendyol === "1");
            setHepsiburadaWorkStatus(editData.isActiveOnHepsiburada === "1");
            setHepsijetWorkStatus(editData.isActiveOnHepsijet === "1");
            setKargoistWorkStatus(editData.isActiveOnKargoist === "1");            
            setIsActive(editData.status === "1");
            setIsBolparaActive(editData.isBolparaActive === "1");

            setArasKargoChecked(!!editData.arasKargoID);
            setKargoistChecked(!!editData.kargoistID);
            setHepsiJetChecked(!!editData.hepsijetID);
            setSuratKargoChecked(editData.isSuratKargo === "1");

            // --- 3. ADIM: Form Data'nın Doldurulması ---
            setFormData({
                users: editData.users ? editData.users : [],
                selectedBranch: selectedBranchValue,
                dolapOptions: selectedBranchValue === 'isBox' ? getDolapOptionsFromPoint(editData) : { ...EMPTY_DOLAP_OPTIONS },
                isAmazon: editData.isAmazon === "1",
                isTrendyol: editData.isTrendyol === "1",
                isHepsiburada: editData.isHepsiburada === "1",
                isKargoist: editData.isKargoist === "1",
                isHepsijet: editData.isHepsijet === "1",
                isArasKargo: editData.isArasKargo === "1",
                isSuratKargo: editData.isSuratKargo === "1",
                arasKargoID: editData.arasKargoID,
                kargoistID: editData.kargoistID,
                hepsijetID: editData.hepsijetID,
                suratKargoID: editData.suratKargoID,
                title: editData.title,
                amazonHubTitle: editData.amazonTitle,
                amazonAddress1: editData.amazonAddress1,
                amazonAddress2: editData.amazonAddress2,
                phone: editData.phone,
                email: editData.email,
                city: editData.city,
                region: editData.region,
                district: editData.district,
                address: editData.muhaberatAddress1,
                address2: editData.muhaberatAddress2,
                postCode: editData.postalCode,
                mallID: editData.mallID,
                floor: editData.floor,
                latitude: editData.latitude,
                longitude: editData.longitude,
                branchCode: editData.branchCode,
                branchSubCode: editData.subBranchCode,
                prefix: editData.prefix,
                dailyCapacity: editData.packageCapacity,
                getirID: editData.getirID,
                workingDaysText: editData.workingDaysText,
                hasPhysicalPOS: String(editData.hasPhysicalPOS) === "1",
                isCash: String(editData.isCash) === "1",
                canUploadInvoice:
                    String(editData.canUploadInvoice ?? editData.canuploadInvoice) === "1",
                workingDays: {
                    monday: getSafeDayData('monday'),
                    tuesday: getSafeDayData('tuesday'),
                    wednesday: getSafeDayData('wednesday'),
                    thursday: getSafeDayData('thursday'),
                    friday: getSafeDayData('friday'),
                    saturday: getSafeDayData('saturday'),
                    sunday: getSafeDayData('sunday')
                },
                pointAddressDefinition: editData.pointAddressDefinition
            });

            if (editData?.responsibleRegionId || editData?.regionID) {
                setSelectedResponsibleRegionId(String(editData?.responsibleRegionId || editData?.regionID));
            } else if (editData?.pointDistrict) {
                setSelectedResponsibleRegionId(String(editData?.pointDistrict));
            } else {
                setSelectedResponsibleRegionId("");
            }
        }
    }, [editData, open]);

    useEffect(() => {
        if (!open || !responsibleRegions?.length) return;
        if (!isEdit) {
            // Yeni kayıtta backend pointDistrict beklediği için varsayılan bölge seç.
            if (!selectedResponsibleRegionId) {
                setSelectedResponsibleRegionId(String(responsibleRegions[0]?.id || ""));
            }
            return;
        }

        if (!selectedResponsibleRegionId && (editData?.responsibleRegionId || editData?.pointDistrict)) {
            setSelectedResponsibleRegionId(String(editData?.responsibleRegionId || editData?.pointDistrict));
        }
    }, [open, isEdit, responsibleRegions, editData?.responsibleRegionId, editData?.pointDistrict]);    

    useEffect(() => {
        if (!open || !isEdit || !editData?.id) return;
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        if (!parsedUser?.token) return;
        Services.GetPoiDetails(parsedUser.token, editData.id)
            .then((res) => {
                if (res?.data?.status) {
                    const hasPhysicalPOS =
                        String(res.data.result?.hasPhysicalPOS) === "1";
                    const isCash =
                        String(res.data.result?.isCash) === "1";
                    const canUploadInvoice =
                        String(res.data.result?.canUploadInvoice ?? res.data.result?.canuploadInvoice) === "1";                    
                    setFormData(prev => ({ ...prev, hasPhysicalPOS, isCash, canUploadInvoice }));
                }
            })
            .catch(() => { });
    }, [open, isEdit, editData?.id]);

    const handleCopyMondayToAll = () => {
        const mondayData = formData.workingDays.monday;
        const updatedWorkingDays = { ...formData.workingDays };
        const otherDays = ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

        otherDays.forEach(day => {
            updatedWorkingDays[day] = {
                enable: mondayData.enable,
                openingTime: { ...mondayData.openingTime },
                closingTime: { ...mondayData.closingTime }
            };
        });
        let newEnabledDaysList = [];
        if (mondayData.enable === "on") {
            // Tüm günler aktif olacak
            newEnabledDaysList = ['monday', ...otherDays];
        } else {
            // Hiçbir gün aktif olmayacak
            newEnabledDaysList = [];
        }
        setWorkingDays(newEnabledDaysList);
        setFormData({
            ...formData,
            workingDays: updatedWorkingDays
        });
        toast.success("Pazartesi saatleri tüm haftaya uygulandı.");
    };
    return (
        <Modal open={open}>
            <>
                <Backdrop
                    sx={{ color: '#fff', zIndex: 2, height: '100%' }}
                    open={isBackdropOpen}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        maxWidth: '90%',
                        maxHeight: '90%',
                        borderRadius: 2,
                        overflow: 'auto',
                        '@media (max-width: 960px)': {
                            maxWidth: '80%',
                            width: '80%',
                        },
                        paddingBottom: 0
                    }}
                >


                    <div style={{ width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                        {isEdit === true ? <DialogTitle>{language.commons.labels.update_point}</DialogTitle> : <DialogTitle>{language.commons.labels.add_point}</DialogTitle>}

                        <div style={{ flexDirection: 'column', display: 'flex' }}>
                            {isEdit &&
                                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                    <Typography>
                                        {language.commons.labels.active_statu}:
                                    </Typography>
                                    <Switch
                                        checked={isActive}
                                        onChange={handleSwitchChange}
                                        name="isActive"
                                        color="primary"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </div>

                            }
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                                <Typography>
                                    BolPara:
                                </Typography>
                                <Switch
                                    checked={isBolparaActive}
                                    onChange={handleSwitchChange}
                                    name="isBolparaActive"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                                <Typography>
                                    Fatura Görünümü:
                                </Typography>
                                <Switch
                                    checked={!!formData.canUploadInvoice}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, canUploadInvoice: !!e.target.checked }))
                                    }
                                    name="canUploadInvoice"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'fatura gorunumu' }}
                                />
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                                <Typography>
                                    Fiziksel POS:
                                </Typography>
                                <Switch
                                    checked={!!formData.hasPhysicalPOS}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, hasPhysicalPOS: !!e.target.checked }))
                                    }
                                    name="hasPhysicalPOS"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end' }}>
                                <Typography>
                                    Nakit Ödeme:
                                </Typography>
                                <Switch
                                    checked={!!formData.isCash}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, isCash: !!e.target.checked }))
                                    }
                                    name="isCash"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'nakit odeme' }}
                                />
                            </div>                            
                        </div>

                    </div>

                    <DialogContent className='mobile-p-0'>

                        <>
                            <Grid item xs={12} container alignItems="center" spacing={0}>

                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Typography>{language.commons.labels.branch_info}:</Typography>
                                        <RadioGroup
                                            aria-label="seçenekler"
                                            name="selectedBranch"
                                            value={formData.selectedBranch}
                                            onChange={handleChangeBranch}
                                            row // Sıralı bir şekilde göstermek için "row" prop'unu ekliyoruz
                                        >
                                            <FormControlLabel value="isEsnaf" control={<Radio />} label={language.commons.roles.tradesmen} />
                                            <FormControlLabel value="isEasyPoint" control={<Radio />} label={language.commons.labels.easypoint} />
                                            {/* Dolap servise isBox olarak gider; eski Express noktaları da Dolap olarak açılır. */}
                                            <FormControlLabel value="isBox" control={<Radio />} label="Dolap" />
                                        </RadioGroup>
                                        {formData.selectedBranch === 'isBox' && (
                                            <div>
                                                {DOLAP_OPTIONS.map(({ key, label }) => {
                                                    const dolapOptions = formData.dolapOptions || EMPTY_DOLAP_OPTIONS;
                                                    return (
                                                        <FormControlLabel
                                                            key={key}
                                                            label={label}
                                                            control={
                                                                <Checkbox
                                                                    name={key}
                                                                    checked={Boolean(dolapOptions[key])}
                                                                    disabled={isDolapOptionDisabled(key, dolapOptions)}
                                                                    onChange={handleChangeDolapOption}
                                                                />
                                                            }
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Typography>{language.commons.labels.working_partner} :</Typography>
                                        <div>
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.isAmazon} disabled={isEdit && editData.isAmazon === "1"} onChange={handleChangePartners} name="isAmazon" />}
                                                label="Amazon"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.isTrendyol} disabled={isEdit && editData.isTrendyol === "1"} onChange={handleChangePartners} name="isTrendyol" />}
                                                label="Trendyol"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={formData.isHepsiburada} disabled={isEdit && editData.isHepsiburada === "1"} onChange={handleChangePartners} name="isHepsiburada" />}
                                                label="Hepsiburada"
                                            />

                                            {isEdit ?
                                                <FormControlLabel
                                                    control={<Checkbox checked={kargoistChecked} disabled={!!editData.kargoistID} onChange={handleChangePartners} name="isKargoist" />}
                                                    label="CargoX"
                                                /> :
                                                <FormControlLabel
                                                    control={<Checkbox checked={kargoistChecked} onChange={handleChangePartners} name="isKargoist" />}
                                                    label="CargoX"
                                                />
                                            }


                                            {isEdit ?
                                                <FormControlLabel
                                                    control={<Checkbox checked={hepsiJetChecked} disabled={!!editData.hepsijetID} onChange={handleChangePartners} name="isHepsiJet" />}
                                                    label="Hepsijet"
                                                />
                                                :
                                                <FormControlLabel
                                                    control={<Checkbox checked={hepsiJetChecked} onChange={handleChangePartners} name="isHepsiJet" />}
                                                    label="Hepsijet"
                                                />
                                            }

                                            {isEdit ?
                                                <FormControlLabel
                                                    control={<Checkbox checked={arasKargoChecked} disabled={!!editData.arasKargoID} onChange={handleChangePartners} name="isArasKargo" />}
                                                    label="Aras Kargo"
                                                />
                                                :
                                                <FormControlLabel
                                                    control={<Checkbox checked={arasKargoChecked} onChange={handleChangePartners} name="isArasKargo" />}
                                                    label="Aras Kargo"
                                                />
                                            }
                                            {isEdit ?
                                                <FormControlLabel
                                                    control={<Checkbox checked={suratKargoChecked} onChange={handleChangePartners} name="isSuratKargo" />}
                                                    label="Sürat Kargo"
                                                />
                                                :
                                                <FormControlLabel
                                                    control={<Checkbox checked={suratKargoChecked} onChange={handleChangePartners} name="isSuratKargo" />}
                                                    label="Sürat Kargo"
                                                />
                                            }

                                        </div>
                                    </Grid>
                                </Grid>

                                {isEdit &&
                                    <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 10 }}>
                                        {formData.isAmazon &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.amazon_working}:
                                                </Typography>
                                                <Switch
                                                    checked={amazonWorkStatus}
                                                    onChange={handleSwitchChange}
                                                    name="amazonWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }
                                        {formData.isTrendyol &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.trendyol_working}:
                                                </Typography>
                                                <Switch
                                                    checked={trendyolWorkStatus}
                                                    onChange={handleSwitchChange}
                                                    name="trendyolWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }

                                        {formData.isHepsiburada &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.hepsi_working}:
                                                </Typography>
                                                <Switch
                                                    checked={hepsiburadaWorkStatus}
                                                    onChange={handleSwitchChange}
                                                    name="hepsiburadaWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }

                                        {kargoistChecked &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.kargoist_working}:
                                                </Typography>
                                                <Switch
                                                    checked={kargoistWorkStatus}
                                                    onChange={handleSwitchChange}
                                                    name="kargoistWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }

                                        {hepsiJetChecked &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.hepsi_jet_working}:
                                                </Typography>
                                                <Switch
                                                    checked={hepsijetWorkStatus}
                                                    onChange={handleSwitchChange}
                                                    name="hepsijetWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }

                                        {arasKargoChecked &&
                                            <>
                                                <Typography>
                                                    {language.commons.labels.aras_kargo_working}:
                                                </Typography>
                                                <Switch
                                                    checked={formData.isArasKargo}
                                                    onChange={handleSwitchChange}
                                                    name="arasKargoWorkStatus"
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            </>
                                        }                                        
                                    </div>
                                }

                                {formData.selectedBranch === 'isEsnaf' &&
                                    <Grid container alignItems="center" spacing={2} sx={{ mt: 0.5, mb: 1 }}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth margin="normal">
                                                <InputLabel id="responsible-region-select-label">Bölge Seç</InputLabel>
                                                <Select
                                                    labelId="responsible-region-select-label"
                                                    label="Bölge Seç"
                                                    value={selectedResponsibleRegionId}
                                                    onChange={(e) => setSelectedResponsibleRegionId(e.target.value)}
                                                >
                                                    {responsibleRegions.map((regionItem) => (
                                                        <MenuItem key={regionItem.id} value={String(regionItem.id)}>
                                                            {regionItem.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label="Sorumlu Kişi"
                                                value={responsibleFullName}
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label="Sorumlu Telefon No"
                                                value={responsiblePhone}
                                                margin="normal"
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {!formData.isAmazon &&
                                    <TextField
                                        fullWidth
                                        label={language.commons.column.title + '*'}
                                        name="title"
                                        value={formData.title}
                                        onChange={handleTextFieldChange}
                                        margin="normal"
                                    />
                                }

                                {isEdit && editData.trendyolID && (editData.isTrendyol === "1" || editData.isTrendyol === true || editData.isTrendyol === 1) &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                label={"Trendyol ID"}
                                                name="trendyolID"
                                                value={editData.trendyolID}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <ContentCopyIcon
                                                                style={{ cursor: 'pointer', color: '#98A2B3' }}
                                                                onClick={() => handleCopy(editData.trendyolID)}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {isEdit && editData.branchCode && (editData.isHepsiburada === "1" || editData.isHepsiburada === true || editData.isHepsiburada === 1) &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled
                                                label={"Hepsiburada ID"}
                                                name="hepsiburadaID"
                                                value={editData.branchCode}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <ContentCopyIcon
                                                                style={{ cursor: 'pointer', color: '#98A2B3' }}
                                                                onClick={() => handleCopy(editData.branchCode)}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {kargoistChecked &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled={isEdit && editData.kargoistID}
                                                label={"Kargoist ID"}
                                                name="kargoistID"
                                                value={formData.kargoistID}
                                                onChange={handleTextFieldChange}
                                                onBlur={(e) => {
                                                    // Edit modda ve değer değişmemişse duplicate kontrolüne gerek yok
                                                    if (!isEdit || (isEdit && e.target.value !== editData.kargoistID)) {
                                                        handleCheckDuplicate("kargoistID", e.target.value);
                                                    }
                                                }}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <ContentCopyIcon
                                                                style={{ cursor: 'pointer', color: '#98A2B3' }}
                                                                onClick={() => handleCopy(editData.kargoistID)}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}

                                            />

                                        </Grid>
                                    </Grid>
                                }

                                {hepsiJetChecked &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled={isEdit && editData.hepsijetID}
                                                label="HepsiJet ID*"
                                                name="hepsijetID"
                                                value={formData.hepsijetID}
                                                onChange={handleTextFieldChange}
                                                onBlur={(e) => {
                                                    // Edit modda ve değer değişmemişse duplicate kontrolüne gerek yok
                                                    if (!isEdit || (isEdit && e.target.value !== editData.hepsijetID)) {
                                                        handleCheckDuplicate("hepsijetID", e.target.value);
                                                    }
                                                }}
                                                margin="normal"
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {arasKargoChecked &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled={isEdit && editData.arasKargoID}
                                                label={language.commons.column.aras_id + '*'}
                                                name="arasKargoID"
                                                value={formData.arasKargoID}
                                                onChange={handleTextFieldChange}
                                                onBlur={(e) => {
                                                    // Edit modda ve değer değişmemişse duplicate kontrolüne gerek yok
                                                    if (!isEdit || (isEdit && e.target.value !== editData.arasKargoID)) {
                                                        handleCheckDuplicate("arasKargoID", e.target.value);
                                                    }
                                                }}
                                                margin="normal"
                                                inputProps={{
                                                    maxLength: 99,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                {/* 
                                {suratKargoChecked &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                disabled={isEdit && editData.suratKargoID}
                                                label={"Sürat Kargo ID*"}
                                                name="suratKargoID"
                                                value={formData.suratKargoID}
                                                onChange={handleTextFieldChange}
                                                onBlur={(e) => {
                                                    if (!isEdit || (isEdit && e.target.value !== editData.suratKargoID)) {
                                                        handleCheckDuplicate("suratKargoID", e.target.value);
                                                    }
                                                }}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <ContentCopyIcon
                                                                style={{ cursor: 'pointer', color: '#98A2B3' }}
                                                                onClick={() => handleCopy(formData.suratKargoID || editData.suratKargoID)}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                inputProps={{
                                                    maxLength: 20, // ID uzunluğuna göre ayarlayabilirsiniz
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                */}

                                {formData.isAmazon &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label={language.commons.column.title + '*'}
                                                name="title"
                                                value={formData.title}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label={language.commons.labels.amazon_hub}
                                                name="amazonHubTitle"
                                                value={formData.amazonHubTitle}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {formData.isAmazon &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label={language.commons.labels.amazon_adress + '*'}
                                                name="amazonAddress1"
                                                value={formData.amazonAddress1}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label={language.commons.labels.amazon_adress2 + '*'}
                                                name="amazonAddress2"
                                                value={formData.amazonAddress2}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                    </Grid>
                                }


                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.phone}
                                            name="phone"
                                            type='number'
                                            value={formData.phone}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                            onInput={(e) => {
                                                let inputValue = e.target.value;
                                                if (inputValue < 0) {
                                                    inputValue = "0"
                                                }
                                                // Eğer ilk karakter 0 ise ve giriş uzunluğu 1'den fazlaysa, ilk karakteri sil
                                                if (inputValue.startsWith('0')) {
                                                    inputValue = inputValue.slice(1);
                                                }
                                                // Maksimum 10 karakter sınırlaması
                                                if (inputValue.length > 10) {
                                                    inputValue = inputValue.slice(0, 10);
                                                }
                                                // Giriş değeri değiştiyse, yeni değeri güncelle
                                                if (inputValue !== e.target.value) {
                                                    e.target.value = inputValue;
                                                    // State'i güncelle
                                                    setFormData({
                                                        ...formData,
                                                        phone: inputValue
                                                    });
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.e_mail + '*'}
                                            name="email"
                                            value={formData.email}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth margin="normal">
                                            <InputLabel>{language.commons.city + '*'}</InputLabel>
                                            <Select
                                                label={language.commons.city + '*'}
                                                name="city"
                                                value={formData.city.toLocaleUpperCase("tr")}
                                                onChange={handleTextFieldChange}
                                            >
                                                {cityList?.map((city) => (
                                                    <MenuItem key={city.code} value={city.name}>
                                                        {city.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth margin="normal">
                                            <InputLabel>{language.commons.state + '*'}</InputLabel>
                                            <Select
                                                disabled={townList?.length === 0}
                                                label={language.commons.state + '*'}
                                                name="district"
                                                value={formData.district.toLocaleUpperCase("tr")}
                                                onChange={handleTextFieldChange}
                                            >
                                                {townList?.map((town) => (
                                                    <MenuItem key={town.code} value={town.name}>
                                                        {town.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.adress_explain + '*'}
                                            name="address"
                                            value={formData.address}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.adress_explain2}
                                            name="address2"
                                            value={formData.address2}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth margin="normal">
                                            <InputLabel>{language.commons.labels.neighbourhood}</InputLabel>
                                            <Select
                                                disabled={regionList?.length === 0}
                                                label={language.commons.labels.neighbourhood}
                                                name="region"
                                                value={formData.region.toLocaleUpperCase("tr")}
                                                onChange={handleTextFieldChange}
                                            >
                                                {regionList?.map((region) => (
                                                    <MenuItem key={region.code} value={region.name}>
                                                        {region.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.post_code + '*'}
                                            name="postCode"
                                            value={formData.postCode}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Adres Tarifi"
                                        name="pointAddressDefinition"
                                        value={formData.pointAddressDefinition}
                                        onChange={handleTextFieldChange}
                                        margin="normal"
                                    />
                                </Grid>
                                {showMallFields &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth margin="normal">
                                                <InputLabel>{language.commons.labels.location_mall}*</InputLabel>
                                                <Select
                                                    label={language.commons.labels.location_mall + '*'}
                                                    value={formData.mallID || ''}
                                                    onChange={handleTextFieldChange}
                                                    name="mallID"
                                                >
                                                    {malls.map((mall) => (
                                                        <MenuItem
                                                            key={mall.id}
                                                            value={mall.id}
                                                        >
                                                            {mall.title}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                fullWidth
                                                label={language.commons.labels.floor}
                                                name="floor"
                                                value={formData.floor || ''}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={`${language.commons.labels.latitude} *`}
                                            name="latitude"
                                            value={formData.latitude}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={`${language.commons.labels.longitude} *`}
                                            name="longitude"
                                            value={formData.longitude}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={`${language.commons.column.branch_code}${formData.isHepsiburada ? ' *' : ''}`}
                                            name="branchCode"
                                            value={formData.branchCode}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                            onBlur={(e) => {
                                                if (!isEdit || (isEdit && e.target.value !== editData.branchCode)) {
                                                    handleCheckDuplicate("branchCode", e.target.value);
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.column.branch_sub_code}
                                            name="branchSubCode"
                                            value={formData.branchSubCode}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.prefix}
                                            name="prefix"
                                            value={formData.prefix}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label={language.commons.labels.daily_capacity + '*'}
                                            type='number'
                                            name="dailyCapacity"
                                            value={formData.dailyCapacity}
                                            onChange={handleTextFieldChange}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                {formData.selectedBranch === 'isEasyPoint' &&
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                disabled={editData?.getirID}
                                                fullWidth
                                                label={language.commons.labels.getir_id}
                                                name="getirID"
                                                value={formData.getirID}
                                                onChange={handleTextFieldChange}
                                                margin="normal"
                                            />
                                        </Grid>
                                    </Grid>
                                }

                                {isEdit && <>
                                    <Grid container alignItems="center" sx={{ marginTop: '15px' }} spacing={2}>
                                        <Grid item xs={12}>
                                            {formData.users.map((user) => (
                                                <Chip
                                                    icon={user.isFirstResponsible ? <Iconify style={{ color: 'white' }} icon={"iconoir:profile-circle"} /> : <Iconify icon={"mdi:eye-outline"} />}
                                                    key={user.id}
                                                    label={`${user.name} ${user.lastname}`}
                                                    style={{ margin: 2, backgroundColor: user.isFirstResponsible && '#DC423C', color: user.isFirstResponsible ? 'white' : 'inherit' }}
                                                    onClick={() => window.open(`/dashboard/edit-point-user/${user.id}`, '_blank')}
                                                />
                                            ))}
                                        </Grid>
                                    </Grid>
                                    <Grid container alignItems="center" sx={{ marginTop: '5px' }} spacing={2}>
                                        <Grid item xs={12} sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                            <Chip
                                                icon={<Iconify icon={"iconoir:profile-circle"} />}
                                                label={`Şube Çalışanı`}
                                                style={{ margin: 2, backgroundColor: 'transparent' }}
                                            />
                                            <Chip
                                                icon={<Iconify icon={"mdi:eye-outline"} />}
                                                label={`Şube gönderilerini görme yetkisine sahip`}
                                                style={{ margin: 2, backgroundColor: 'transparent' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                                }

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label={language.commons.labels.workingDaysText}
                                        name="workingDaysText"
                                        value={formData.workingDaysText}
                                        onChange={handleTextFieldChange}
                                        margin="normal"
                                    />
                                </Grid>

                                <Grid item xs={12} sx={{ marginTop: '10px' }}>
                                    <Typography>{language.commons.labels.working_days_hour}:</Typography>
                                    <FormControl sx={{ marginTop: 2 }} component="fieldset">
                                        <Grid xs={12} md={12} xl={12} container alignItems="center" spacing={2}>
                                            {Object.keys(formData.workingDays).map((day, index) => (
                                                <>
                                                    {day === 'monday' && (
                                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px', marginBottom: '10px' }}>
                                                            <Button
                                                                size="small"
                                                                variant="text"
                                                                color="primary"
                                                                onClick={handleCopyMondayToAll}
                                                                startIcon={<ContentCopyIcon fontSize="small" />} // İkon varsa güzel durur
                                                                disabled={formData.workingDays.monday.enable !== "on"} // Pazartesi kapalıysa kopyalama yapmasın
                                                            >
                                                                Pazartesi saatlerini diğer günlere uygula
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                    <Grid item xs={2} md={2} xl={2}>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={workingDays.includes(day)} onChange={handleDayChange} name={day} />}
                                                            label={days[index]}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={5} xl={2} >
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <TimePicker
                                                                key={day}
                                                                timeSteps={{ minutes: 30 }}
                                                                clearable
                                                                label={language.commons.labels.start_time}
                                                                ampm={false}
                                                                disabled={formData.workingDays[day].enable !== "on"}
                                                                value={moment().hours(parseInt(formData.workingDays[day].openingTime.hour)).minutes(parseInt(formData.workingDays[day].openingTime.minute))}
                                                                onChange={(newTime) => handleOpeningTimeChange(newTime, day)}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={5} xl={2}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <TimePicker
                                                                key={day}
                                                                timeSteps={{ minutes: 30 }}
                                                                clearable
                                                                label={language.commons.labels.end_time}
                                                                ampm={false}
                                                                disabled={formData.workingDays[day].enable !== "on"}
                                                                value={moment().hours(parseInt(formData.workingDays[day].closingTime.hour)).minutes(parseInt(formData.workingDays[day].closingTime.minute))}
                                                                onChange={(newTime) => handleClosingTimeChange(newTime, day)}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>
                                                </>
                                            ))}
                                        </Grid>
                                    </FormControl>
                                </Grid>
                                {isEdit &&
                                    <>
                                        <Grid item xs={12} sx={{ marginTop: '15px' }}>
                                            <Typography>{language.commons.labels.close_time_day}:</Typography>
                                            <FormControl sx={{ marginTop: 2 }} component="fieldset">
                                                <Grid xs={12} container alignItems="center" spacing={1}>
                                                    <Grid item xs={3}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <DatePicker
                                                                format="DD/MM/YYYY"
                                                                label={language.commons.labels.start_date}
                                                                value={startDate}
                                                                onChange={(newValue) => { setStartDate(newValue), setEndDate(null) }}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <TimePicker
                                                                timeSteps={{ minutes: 30 }}
                                                                label={language.commons.labels.start_time}
                                                                clearable
                                                                ampm={false}
                                                                value={closedTimeStart}
                                                                onChange={(newValue) => { setClosedTimeStart(newValue), setClosedTimeEnd(null) }}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <DatePicker
                                                                format="DD/MM/YYYY"
                                                                label={language.commons.labels.end_date}
                                                                value={endDate}
                                                                minDate={startDate}
                                                                disabled={!startDate}
                                                                onChange={(newValue) => setEndDate(newValue)}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>

                                                    <Grid item xs={3}>
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <TimePicker
                                                                timeSteps={{ minutes: 30 }}
                                                                label={language.commons.labels.end_time}
                                                                clearable
                                                                ampm={false}
                                                                value={closedTimeEnd}
                                                                minTime={closedTimeStart}
                                                                disabled={!closedTimeStart}
                                                                onChange={setClosedTimeEnd}
                                                            />
                                                        </LocalizationProvider>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disabled={!startDate || !endDate || !closedTimeStart || !closedTimeEnd || closedDates.length > 0}
                                                            onClick={handleAddClosedDates}
                                                        >
                                                            {language.commons.add}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </FormControl>
                                        </Grid>

                                        {closedDates?.length > 0 &&
                                            <Grid container alignItems="center" spacing={2} sx={{ marginTop: '15px' }}>
                                                {closedDates.map((date, index) => (
                                                    <Grid item xs={4} key={index}>
                                                        <Chip
                                                            key={index}
                                                            label={`${new Date(date.startDate * 1000).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' })} - ${new Date(date.endDate * 1000).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' })}`}
                                                            onDelete={() => handleDeleteClosedDate(index)}
                                                            color="default"
                                                            variant="outlined"
                                                            deleteIcon={<CancelIcon style={{ color: 'red' }} />}
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        }
                                    </>
                                }

                            </Grid>
                        </>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            {language.commons.back}
                        </Button>
                        {applicationData && (
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => handleSave(true)}
                                disabled={!allFieldsAreValid()}
                            >
                                Kaydet ve Noktaya Git
                            </Button>
                        )}
                        <Button
                            color="primary"
                            onClick={() => handleSave(false)}
                            variant="contained"
                            disabled={!allFieldsAreValid()}
                        >
                            {language.commons.save}
                        </Button>
                    </DialogActions>
                </Box>

                <Dialog
                    open={showResultMessage}
                    onClose={handleCloseMessage}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {isEdit === true ?
                        <DialogTitle id="alert-dialog-title">{language.commons.labels.update_point}</DialogTitle>
                        :
                        <DialogTitle id="alert-dialog-title">{language.commons.labels.add_point}</DialogTitle>
                    }
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {resultMessage}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseMessage}>{language.commons.okay}</Button>
                    </DialogActions>
                </Dialog>
            </>
        </Modal >
    );
};

export default AddEditPointModal;
